import { z } from "zod";

export const setPasswordSchema = z
  .object({
    password: z.string().min(1, "Password is required"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Password do not match",
    path: ["confirmPassword"],
  });

export type SetPasswordFormData = z.infer<typeof setPasswordSchema>;

export const defaultValues: SetPasswordFormData = {
  password: "",
  confirmPassword: "",
};

export const PAGE_CONFIG = {
  TITLE: "Set Password",
} as const;
